// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { ofType } from "redux-observable"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { MANUAL_TIME_ACTIVITY } from "./index"
import { ActivityTypeOption, generateActivityOptions } from "../activities"

export type StorageReader = () => Observable<ActivityTypeOption>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(MANUAL_TIME_ACTIVITY)
    const storedActivity = data && JSON.parse(data)
    if (storedActivity !== null && generateActivityOptions().some(option => option.value === storedActivity.value)) {
      return of(storedActivity)
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadActivity = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadActivityFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setInputActivity),
        catchError(_ => of(Actions.loadActivityFromStorageFailed())),
      )),
    )

export default loadActivity(load)
